import { apiFetch, getAuthHeaders } from './apiUtils';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Cache for token balance
let tokenBalanceCache = null;
let tokenBalanceCacheTime = null;
const CACHE_DURATION = 5000; // 5 seconds

export const fetchTokenBalance = async (getAccessTokenSilently) => {
  try {
    const headers = await getAuthHeaders(getAccessTokenSilently);
    const data = await apiFetch('/api/tokens/balance', { headers });
    
    // Handle special case for Infinity
    if (data.balance === 'Infinity' || data.balance === Infinity) {
      return Infinity;
    }
    
    return data.balance || 0;
  } catch (error) {
    console.error('Error fetching token balance:', error);
    return 0;
  }
};

export const fetchTokenAllowance = async (getAccessTokenSilently) => {
  try {
    const headers = await getAuthHeaders(getAccessTokenSilently);
    const data = await apiFetch('/api/tokens/allowance', { headers });
    return data.monthlyAllowance || 0;
  } catch (error) {
    // Error fetching token allowance - silenced for production
    return 0;
  }
}; 